<template>
    <v-card flat>
        <v-card-text class="pl-0 pr-0 pb-0">
            <tile-search-header
                :search-param="searchParam"
                @search-date-inited="searchDateInited"
                @search-date-changed="searchDateChanged"
                @search="doSearch"
            ></tile-search-header>
            <v-card flat class="mt-4">
                <v-simple-table class="border-table">
                    <template v-slot:default>
                        <thead>
                        <tr style="background-color:#F4F6F8; height:78px; color:#333333; font-weight:600;">
                            <th class="text-center text-h6">이름</th>
                            <th class="text-center text-h6">수신전화</th>
                            <th class="text-center text-h6">통화연결</th>
                            <th class="text-center text-h6">안심전화</th>
                            <th class="text-center text-h6">콜백처리</th>
                            <th class="text-center text-h6">총통화시간</th>
                        </tr>
                        </thead>
                        <tbody style="color:#555555;">
                        <template v-for="(statItem, statIdx) in statList">
                            <tr style="height:68px;" :key="statIdx">
                                <td class="text-center" style="font-size:20px;">
                                    <span :class="{'text-decoration-line-through' : (statItem.user_del_yn == 'Y')}">{{ statItem.user_name }}</span>
                                </td>
                                <td class="text-center" style="font-size:20px;">{{ statItem.trans_try_count }}</td>
                                <td class="text-center" style="font-size:20px;">{{ statItem.trans_succ_count }}</td>
                                <td class="text-center" style="font-size:20px;">{{ statItem.safe_call_count }}</td>
                                <td class="text-center" style="font-size:20px;">{{ statItem.callback_answer_count }}</td>
                                <td class="text-center" style="font-size:20px;">{{ statItem.safe_call_time + statItem.trans_call_time | secTime }}</td>
                            </tr>
                        </template>
                        <tr style="height:69px;" v-if="!statList || statList.length == 0">
                            <td class="text-center" style="font-size:20px;" colspan="6">조회된 결과가 없습니다</td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-card-text>
    </v-card>
</template>
<script>
import {mapState} from 'vuex'

export default {
    name: 'stats_user_list',
    components: {
        'TileSearchHeader': () => import('@/components/stats/tile_search_header.vue'),
    },
    data: () => ({
        searchParam: {
            search_start: '',
            search_end: '',
        },
        initFlags: {'search_date': false},
    }),
    created() {
        this.$store.commit('layoutFlag', true)
        this.$store.commit('menuId', 'stats_user')

        let lastMenuId = this.$store.getters['lastMenuId']
        if (lastMenuId == 'stats_user' && this.curSearchParam) {
            Object.assign(this.search, this.curSearchParam)
        }

        this.doSearch(1)
    },
    computed: {
        ...mapState('stats_user', {
            curSearchParam: state => state.searchParam,
            totalCount: state => state.totalCount,
            statList: state => state.statList,
        }),
        isLoaded() {
            if (this.statList) {
                return true
            }
            return false
        }
    },
    methods: {
        searchDateInited(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
            this.initFlags['search_date'] = true
            this.doSearch()
        },
        searchDateChanged(payload) {
            if (payload && payload.from_day) {
                this.searchParam.search_start = payload.from_day
            }
            if (payload && payload.to_day) {
                this.searchParam.search_end = payload.to_day
            }
        },
        doSearch(no) {
            if (!this.initFlags.search_date) {
                return
            }

            this.$store.dispatch('stats_user/getStatList', {
                searchParam: this.searchParam,
                scb: (stat_list, total_count, va) => {
                },
                fcb: (err, va) => {
                },
                va: this
            })
        }
    }
}
</script>